const formatUrl = (url: string, sandbox?: string | boolean): string =>
  sandbox && url.indexOf('https://api.') !== -1
    ? url.replace('https://api.', 'https://api-sandbox.')
    : sandbox && url.indexOf('https://api-stg.') !== -1
      ? url.replace('https://api-stg.', 'https://api-stg-sandbox.')
      : url

export default formatUrl
